// Progress dots for the right-pane progressive-reveal flow.
// One dot per column; lit when at least one selection in that column.
export default function ProgressDots({ selectedValues, columns }) {
  return (
    <div className="flex items-center gap-1 shrink-0">
      {columns.map((groups, i) => {
        const filled = groups.some((g) => selectedValues?.[g]);
        return (
          <span
            key={i}
            className={`w-1.5 h-1.5 rounded-full ${
              filled ? "bg-emerald-400" : "bg-text-secondary/40"
            }`}
            title={`Column ${i + 1}${filled ? " · selected" : " · pending"}`}
          />
        );
      })}
    </div>
  );
}
